/**
 * Date formatting utilities
 */
export function formatDate(date, _formatString = 'MMM d, yyyy') {
    if (!date)
        return '—';
    try {
        const parsedDate = typeof date === 'string' ? new Date(date) : new Date(date);
        if (Number.isNaN(parsedDate.getTime()))
            return '—';
        // Use Intl.DateTimeFormat for basic formatting
        const defaultOptions = {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
        };
        return new Intl.DateTimeFormat('en-US', defaultOptions).format(parsedDate);
    }
    catch {
        return '—';
    }
}
export function formatDateTime(date) {
    if (!date)
        return '—';
    try {
        const parsedDate = typeof date === 'string' ? new Date(date) : new Date(date);
        if (Number.isNaN(parsedDate.getTime()))
            return '—';
        return new Intl.DateTimeFormat('en-US', {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
        }).format(parsedDate);
    }
    catch {
        return '—';
    }
}
export function formatRelativeTime(date) {
    if (!date)
        return '—';
    try {
        const parsedDate = typeof date === 'string' ? new Date(date) : new Date(date);
        if (Number.isNaN(parsedDate.getTime()))
            return '—';
        const now = new Date();
        const diffInSeconds = Math.floor((now.getTime() - parsedDate.getTime()) / 1000);
        if (diffInSeconds < 60)
            return 'just now';
        if (diffInSeconds < 3600)
            return `${Math.floor(diffInSeconds / 60)}m ago`;
        if (diffInSeconds < 86400)
            return `${Math.floor(diffInSeconds / 3600)}h ago`;
        if (diffInSeconds < 2592000)
            return `${Math.floor(diffInSeconds / 86400)}d ago`;
        return formatDate(parsedDate);
    }
    catch {
        return '—';
    }
}
export function formatShortDate(date) {
    return formatDate(date, 'MMM d');
}
export function formatLongDate(date) {
    if (!date)
        return '—';
    try {
        const parsedDate = typeof date === 'string' ? new Date(date) : new Date(date);
        if (Number.isNaN(parsedDate.getTime()))
            return '—';
        return new Intl.DateTimeFormat('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
        }).format(parsedDate);
    }
    catch {
        return '—';
    }
}
export function isValidDate(date) {
    if (!date)
        return false;
    try {
        const parsedDate = typeof date === 'string' ? new Date(date) : new Date(date);
        return !Number.isNaN(parsedDate.getTime());
    }
    catch {
        return false;
    }
}
export function getCurrentISODate() {
    return new Date().toISOString();
}
export function parseDate(dateString) {
    try {
        const parsed = new Date(dateString);
        return Number.isNaN(parsed.getTime()) ? null : parsed;
    }
    catch {
        return null;
    }
}
//# sourceMappingURL=date.js.map